export default "__VITE_ASSET__BSqOURWz__"